import { ThemeColors } from '../../../'

export interface FaxListViewColors {
  ScrollingList: {
    Item: {
      Subtitle: {
        Icon: {
          Inbound: ThemeColors
          Success: ThemeColors
          Failure: ThemeColors
        }
        FontColor: {
          Failed: ThemeColors
        }
      }
    }
  }
}

export const faxListViewColors: FaxListViewColors = {
  ScrollingList: {
    Item: {
      Subtitle: {
        Icon: {
          Inbound: {
            default: 'green.fg',
          },
          Success: {
            default: 'blue.fg',
          },
          Failure: {
            default: 'red.fg',
          },
        },
        FontColor: {
          Failed: {
            default: 'red.fg',
          },
        },
      },
    },
  },
}
